<div class="app_modal">
    <div class="app_modal_body">
        <ng-content></ng-content>
    </div>
</div>
<div class="app_modal_background"></div>
